(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hd-collection"]) return;
  try {
    
  class HdCollection {
    constructor(root) {
      this.root = root;
      this.sectionId = root.dataset.sectionId;
      this.results = root.querySelector('[data-hd-results]');
      this.root.classList.add('hd-col--js');
      this.bind();
    }

    bind() {
      // Drawer mobile
      this.root.querySelectorAll('[data-hd-open-filters]').forEach((b) =>
        b.addEventListener('click', () => this.openDrawer())
      );
      this.root.querySelectorAll('[data-hd-close-filters]').forEach((b) =>
        b.addEventListener('click', () => this.closeDrawer())
      );
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.closeDrawer();
      });

      // Ordenação: auto-submit (AJAX)
      const sortForm = this.root.querySelector('[data-hd-sort]');
      if (sortForm) {
        sortForm.querySelector('select').addEventListener('change', () => {
          this.navigate(this.formUrl(sortForm));
        });
      }

      // Filtros: auto-aplica ao mudar (desktop) + submit
      const filterForm = this.root.querySelector('[data-hd-filter-form]');
      if (filterForm) {
        filterForm.addEventListener('submit', (e) => {
          e.preventDefault();
          this.navigate(this.formUrl(filterForm));
          this.closeDrawer();
        });
        filterForm.addEventListener('change', (e) => {
          if (window.matchMedia('(min-width: 990px)').matches || e.target.type === 'checkbox') {
            this.navigate(this.formUrl(filterForm));
          }
        });
      }
    }

    openDrawer() {
      this.root.classList.add('hd-col--filters-open');
      const ov = this.root.querySelector('.hd-col__overlay');
      if (ov) ov.hidden = false;
      const t = this.root.querySelector('[data-hd-open-filters]');
      if (t) t.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    closeDrawer() {
      this.root.classList.remove('hd-col--filters-open');
      const t = this.root.querySelector('[data-hd-open-filters]');
      if (t) t.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    formUrl(form) {
      const params = new URLSearchParams(new FormData(form));
      // remove chaves vazias (ex.: preço em branco)
      const clean = new URLSearchParams();
      for (const [k, v] of params.entries()) {
        if (v !== '' && v != null) clean.append(k, v);
      }
      const base = form.getAttribute('action') || window.location.pathname;
      const qs = clean.toString();
      return qs ? `${base}?${qs}` : base;
    }

    async navigate(url) {
      try {
        this.root.classList.add('is-loading');
        const fetchUrl = new URL(url, window.location.origin);
        fetchUrl.searchParams.set('section_id', this.sectionId);
        const res = await fetch(fetchUrl.toString());
        if (!res.ok) throw new Error('fetch failed');
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-hd-collection]');
        if (!fresh) throw new Error('section not found');
        this.root.innerHTML = fresh.innerHTML;
        window.history.pushState({}, '', url);
        this.results = this.root.querySelector('[data-hd-results]');
        this.bind();
        this.root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } catch (err) {
        window.location.href = url;
      } finally {
        this.root.classList.remove('is-loading');
      }
    }
  }

  function initHdCollections() {
    document.querySelectorAll('[data-hd-collection]').forEach((el) => {
      if (!el.__hdInit) {
        el.__hdInit = true;
        new HdCollection(el);
      }
    });
  }
  document.addEventListener('DOMContentLoaded', initHdCollections);
  initHdCollections();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hd-hero"] && !Shopify.designMode) return;
  try {
    
  function hdHeroSlideshowInit() {
    document.querySelectorAll('[data-hd-hero-ss]').forEach((root) => {
      if (root.__hdHero) return;
      root.__hdHero = true;
      const track = root.querySelector('[data-hd-track]');
      const slides = Array.from(root.querySelectorAll('[data-hd-slide]'));
      const dots = Array.from(root.querySelectorAll('[data-hd-dot]'));
      if (!track || slides.length < 2) return;
      let idx = 0;
      const go = (i) => {
        idx = (i + slides.length) % slides.length;
        track.scrollTo({ left: slides[idx].offsetLeft, behavior: 'smooth' });
      };
      const sync = () => {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        if (i === idx) return;
        idx = i;
        dots.forEach((d, di) => d.classList.toggle('is-active', di === i));
      };
      track.addEventListener('scroll', () => window.requestAnimationFrame(sync), { passive: true });
      dots.forEach((d, di) => d.addEventListener('click', () => go(di)));
      root.querySelector('[data-hd-prev]')?.addEventListener('click', () => go(idx - 1));
      root.querySelector('[data-hd-next]')?.addEventListener('click', () => go(idx + 1));
      const secs = parseFloat(getComputedStyle(root).getPropertyValue('--hd-hero-interval')) || 5;
      let timer;
      const start = () => { timer = setInterval(() => go(idx + 1), secs * 1000); };
      const stop = () => clearInterval(timer);
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('touchstart', stop, { passive: true });
      start();
    });
  }
  document.addEventListener('DOMContentLoaded', hdHeroSlideshowInit);
  hdHeroSlideshowInit();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hd-recommendations"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function bindCarousel(root) {
      const track = root.querySelector('.hd-recs__grid');
      const prev = root.querySelector('[data-hd-prev]');
      const next = root.querySelector('[data-hd-next]');
      if (!track || !prev || !next) return;
      /* a flag vive no trilho: sobrevive à troca de conteúdo do <ul> */
      if (track.__hdBound) return;
      track.__hdBound = true;
      const step = () => Math.max(track.clientWidth * 0.85, 240);
      prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
      const update = () => {
        const max = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max;
      };
      track.addEventListener('scroll', () => window.requestAnimationFrame(update), { passive: true });
      /* ResizeObserver morre junto com o trilho; um listener no window vazaria */
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
      else window.addEventListener('resize', update, { passive: true });
      update();
    }

    /* O Liquid pode estourar no meio do loop do grid e devolver 200 com a
       resposta COMPLETA mas sem os cards (ou com só parte deles). Injetar isso
       quebrava a seção — cards sumiam e a altura disparava. Só aceitamos a
       resposta quando ela bate exatamente com o que o servidor prometeu. */
    function extractGrid(text) {
      if (text.indexOf('Liquid error') !== -1) return null;
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const grid = doc.querySelector('.hd-recs__grid');
      if (!grid) return null;
      const expected = parseInt(grid.getAttribute('data-hd-recs-count'), 10);
      if (!expected || expected < 1) return null;
      if (grid.querySelectorAll('.hd-recs__cell').length !== expected) return null;
      return grid;
    }

    function initRecs() {
      document.querySelectorAll('[data-hd-recs]').forEach((el) => {
        if (el.__hdRecsInit) return;
        el.__hdRecsInit = true;

        /* o fallback já veio pronto do servidor: o carrossel funciona antes do AJAX */
        bindCarousel(el);

        const url = el.dataset.url;
        if (!url) return;

        let tries = 0;
        const load = () => {
          tries += 1;
          fetch(url)
            .then((r) => {
              if (!r.ok) throw new Error('HTTP ' + r.status);
              return r.text();
            })
            .then((text) => {
              const freshGrid = extractGrid(text);
              if (!freshGrid) return; /* resposta ruim: mantém o que está na tela */
              const grid = el.querySelector('.hd-recs__grid');
              if (grid) {
                /* troca só o conteúdo do <ul> — o cabeçalho e a estrutura da
                   seção nunca são tocados, então nenhuma resposta consegue
                   deformar o layout. */
                grid.innerHTML = freshGrid.innerHTML;
                grid.setAttribute('data-hd-recs-count', freshGrid.getAttribute('data-hd-recs-count'));
                grid.scrollLeft = 0;
              } else {
                /* seção nasceu sem grid (nada renderizável): monta a partir da resposta */
                const doc = new DOMParser().parseFromString(text, 'text/html');
                const fresh = doc.querySelector('[data-hd-recs]');
                if (!fresh) return;
                el.innerHTML = fresh.innerHTML;
                bindCarousel(el);
              }
              el.dataset.hdRecsState = 'recs';
            })
            .catch((e) => {
              console.warn('[hd-recs]', e);
              /* rede móvel instável: uma segunda tentativa antes de desistir
                 (desistir é seguro — o fallback continua na tela). */
              if (tries < 2) setTimeout(load, 1200);
            });
        };

        if ('IntersectionObserver' in window) {
          const obs = new IntersectionObserver(
            (entries, observer) => {
              /* num scroll rápido o IO entrega entradas em lote — olhar só
                 entries[0] perde a que de fato intersecta. */
              if (!entries.some((entry) => entry.isIntersecting)) return;
              observer.disconnect();
              load();
            },
            { rootMargin: '0px 0px 600px 0px' }
          );
          obs.observe(el);
        } else {
          load();
        }
      });
    }
    document.addEventListener('DOMContentLoaded', initRecs);
    initRecs();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
